


export enum RegionKeyEnum {
	jihocesky = 'cz-jihocesky',
	jihomoravsky = 'cz-jihomoravsky',
	karlovarsky = 'cz-karlovarsky',
	kralovehradecky = 'cz-kralovehradecky',
	liberecky = 'cz-liberecky',
	moravskoslezsky = 'cz-moravskoslezsky',
	olomoucky = 'cz-olomoucky',
	pardubicky = 'cz-pardubicky',
	plzensky = 'cz-plzensky',
	praha = 'cz-praha',
	stredocesky = 'cz-stredocesky',
	ustecky = 'cz-ustecky',
	vysocina = 'cz-vysocina',
	zlinsky = 'cz-zlinsky',

	banskobystricky = 'sk-banskobystricky',
	bratislavsky = 'sk-bratislavsky',
	kosicky = 'sk-kosicky',
	nitriansky = 'sk-nitriansky',
	presovsky = 'sk-presovsky',
	trenciansky = 'sk-trenciansky',
	trnavsky = 'sk-trnavsky',
	zilinsky = 'sk-zilinsky',
}